import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import "./PageTopBarButton.scss";

const PageTopBarButton = (props) => {
  const ref = useRef(null);

  let mainClassName = classNames({
    "page-topbar-button-content": true,
    "page-topbar-button-left": props.align === "left",
  });

  let buttonClassName = classNames({
    "page-topbar-button": true,
  });

  let iconClassName = classNames({
    "page-topbar-button-icon": true,
    "page-topbar-button-icon-onDark": props.isOnDark === true,
  });

  useEffect(() => {
    if (!!props.onRef) {
      props.onRef(ref);
    }
  }, []);

  return !!props.isVisible ? (
    <div className={mainClassName} ref={ref}>
      <button id={props.id} className={buttonClassName} onClick={props.onClick}>
        <div className={iconClassName}>{props.icon}</div>
      </button>
      {props.dropdown}
    </div>
  ) : (
    ""
  );
};

export default PageTopBarButton;
